import * as React from 'react'
import { useStoreActions } from '../store'
import { pushToDataLayer } from '../state/services'
import discountIcon from "../assets/discount-coupon.svg";

interface ExpressFlowSelectorProps {
  image: string
  serviceName: string
  servicePrice: string
  comparePrice: string
  discountInfo: string
  discountValue: string
  description: string
  bookTreatmentUrl: string
  bookTreatmentText: string
}

export const ExpressFlowSelector = ({
  image,
  serviceName,
  servicePrice,
  comparePrice = "",
  discountInfo = "Online Booking",
  discountValue = "",
  description,
  bookTreatmentUrl,
  bookTreatmentText = "Book a Treatment",
}: ExpressFlowSelectorProps) => {
  const { navigateForward } = useStoreActions();

  const handleConsultationClick = () => {
    pushToDataLayer('hydrafacial_ecomm', {
      button_clicked: 'Book a Free Consultation',
      service_name: serviceName,
      service_price: servicePrice
    });
    navigateForward();
  };

  const handleTreatmentClick = () => {
    pushToDataLayer('hydrafacial_ecomm', {
      button_clicked: 'Book a Treatment',
      service_name: serviceName,
      service_price: servicePrice
    });
  };

  return (
    <div className="express-flow-selector max-w-72">
      {image && (
        <img 
          src={image} 
          alt={serviceName}
          className="express-flow-selector__image w-auto object-cover"
        />
      )}
      <div className="express-flow-selector__content">
        <span className="express-flow-selector__service-name text-2xl mt-5 mb-3 font-bold block">{serviceName}</span>
        <span className="express-flow-selector__service-price text-sm font-bold block">
          {servicePrice}
        </span>
        {comparePrice && (
          <span className="express-flow-selector__service-compare-price text-xs block mt-1">
            {comparePrice}
          </span>
        )}
        {discountValue && (
          <span className="express-flow-selector__service-discount text-sm uppercase font-bold flex justify-between items-center w-full box-border mt-4 text-xxs text-green-dark bg-green-light rounded-sm px-4 py-2">
            <span className="flex items-center">
              <img src={discountIcon} alt="discount" className="mr-2" />
              <span>{discountInfo}</span>
            </span>
              <span>{discountValue}</span>
          </span>
        )}
        <p className="express-flow-selector__description text-sm my-6 text-gray-500 max-w-[25rem]" dangerouslySetInnerHTML={{ __html: description }}></p>
        <div className="express-flow-selector__actions flex flex-col gap-3">
          <button
            onClick={handleConsultationClick}
            className="express-flow-selector__button express-flow-selector__button--primary rounded-full bg-pink-electric standard-form__next-button p-4 text-white w-full sm:w-80 md:w-100 font-semibold text-base mb-3 text-center"
          >
          Book a Free Consultation 
          </button>
          <a
            href={bookTreatmentUrl}
            onClick={handleTreatmentClick}
            className="express-flow-selector__button express-flow-selector__button--secondary rounded-full bg-pink-electric standard-form__next-button p-4 text-white w-full sm:w-80 md:w-100 box-border font-semibold text-base mb-3 text-center"
          >
            {bookTreatmentText}
          </a>
        </div>
      </div>
    </div>
  )
} 